<template>
  <div>
    <v-container style="padding-bottom: 160px">
      <v-layout>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != ''"
            :color="filter == '' ? 'primary' : 'grey'"
            @click="changeApp('')"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="changeApp('facebook')"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="changeApp('line')"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template>
            <v-btn :loading="loading" @click="exportData" color="grey" outline class="ma-0 mb-1">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <date-filter
        @changeDate="getData"
        :defaultFilter="'today'"
        v-model="selectedDate"
      ></date-filter>

      <div class="mb-2">
        <div class="mt-3 mb-2">
          <multiselect
            selectLabel
            @input="changeRound"
            :allowEmpty="false"
            selectedLabel
            :searchable="false"
            deselect-label
            v-model="round"
            :options="allTopic"
          ></multiselect>
        </div>
      </div>
      <div v-if="data && data.length">
        <div>
          <apexchart
            class="mx-auto text-xs-center participatetero"
            :key="barchartkey"
            type="pie"
            width="380"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
        <div class="mt-3">
          <!-- <Pagination :limit="10" :total="total" @onChange="onChangePage"> -->
          <v-data-table
            :pagination.sync="pagination"
            :key="barchartkey"
            :loading="loading"
            :headers="headers"
            :items="filtereddata"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <!-- <td>{{ props.item.id }}</td> -->
                <td>{{ props.item.name }}</td>
                <td class="text-xs-left">
                  <span style="color: #3b5998; cursor: pointer" v-if="props.item.app == 'facebook'">
                    <v-chip
                      @click="goToLivechat(props.item.userid, props.item.app)"
                      small
                      dark
                      color="#3b5998"
                    >
                      <em
                        style="font-size: 15px; margin-right: 5px"
                        class="fab fa-facebook-square"
                      />{{ $t('View inbox') }}
                    </v-chip>
                  </span>
                  <span style="color: #00c300" v-else-if="props.item.app == 'line'">
                    <v-chip
                      @click="goToLivechat(props.item.userid, props.item.app)"
                      small
                      dark
                      color="#00c300"
                      style="cursor: pointer"
                    >
                      <em style="font-size: 15px; margin-right: 5px" class="fab fa-line" />{{
                        $t('View inbox')
                      }}
                    </v-chip>
                  </span>
                </td>
                <td class="text-xs-left">
                  <span style="color: #3b5998" v-if="props.item.app == 'facebook'">
                    {{ props.item.userid ? props.item.userid.split('__')[0] : '-' }}
                  </span>
                  <span style="color: #00c300" v-else-if="props.item.app == 'line'">
                    {{ props.item.userid ? props.item.userid.split('__')[0] : '-' }}
                  </span>
                </td>

                <td>{{ props.item.answer }}</td>
                <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              </tr>
            </template>
          </v-data-table>
          <!-- </Pagination> -->
        </div>
      </div>
      <div v-else-if="!loading">
        <h4 style="color: darkgrey" class="text-xs-center mt-5">ยังไม่มีข้อมูลการโหวต</h4>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '../DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Pagination from '@/components/elements/Pagination2.vue'
import apexchart from 'vue-apexcharts'
import XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
export default {
  computed: {
    ...mapGetters(['selectedBot', 'currentLang']),
    filtereddata() {
      return this.data.filter((el) => {
        return el.topic == this.round
      })
    }
  },
  components: {
    DateFilter,
    apexchart,
    Pagination,
    Multiselect
  },
  data() {
    return {
      barchartkey: 0,
      series: [],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      data: [],
      total: 0,
      agesData: [],
      allTopic: [],
      headers: [
        { text: 'ชื่อ', value: 'name' },
        { text: 'Inbox', value: 'app' },
        { text: 'Userid', value: 'userid' },
        { text: 'Vote', value: 'answer' },
        { text: 'Datetime', value: 'timestamp' }
      ],
      round: '',
      filter: '',
      pagination: { sortBy: 'timestamp', descending: true, rowsPerPage: 10 },
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'Participate'

      var json = []
      var currentData = this.data.find((el) => el.name == this.round)
      json = this.data.map((el) => {
        return {
          No: el.id,
          Name: el.name,
          Channel: el.app,
          Vote: el.topic,
          Answer: el.answer,
          Datetime: moment(el.timestamp).format('YYYY-MM-DD')
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    onChangePage() {},
    changeApp(item) {
      this.filter = item
      //   this.getData()
    },
    changeRound() {
      var data = this.agesData
      var ages = []
      var currentQuestion = data.find((el) => el.name == this.round)

      for (const [key, value] of Object.entries(currentQuestion.ages)) {
        ages.push({
          age: key,
          value
        })
      }
      this.series = ages.map((el) => el.value)
      this.chartOptions.labels = ages.map((el) => el.age + ' year')
      this.barchartkey = new Date().getTime()
    },
    getData() {
      this.getAges()
      var data = {
        pageid: this.selectedBot.pageid,
        topic: '',
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      this.loading = true
      api.postterovoteparticipants(data, (err, response) => {
        this.loading = false
        if (response.data && response.data.length) {
          var topics = response.data.map((el) => el.topic)
          this.allTopic = [...new Set(topics)]
          this.round = this.allTopic[0]
          this.data = response.data
        } else {
          this.allTopic = []
          this.round = ''
          this.data = []
        }
      })
    },
    goToLivechat: function (userid, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: userid,
          // user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    getAges() {
      var data = {
        pageid: this.selectedBot.pageid, // required
        topic: '', // ชื่อคำถาม
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        app: this.filter
      }
      api.postterovoteresult(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          if (response.data && response.data.length) {
            var response = response.data[0]
            var data = []
            for (const [key, value] of Object.entries(response)) {
              data.push({
                name: key,
                ...value
              })
            }
            this.agesData = data
            var ages = []

            for (const [key, value] of Object.entries(data[0].ages)) {
              ages.push({
                age: key,
                value
              })
            }
            this.series = ages.map((el) => el.value)

            this.chartOptions.labels = ages.map((el) => el.age + ' year')
            this.barchartkey = new Date().getTime()
          } else {
            this.agesData = []
            this.series = []
            this.chartOptions.labels = []
            this.barchartkey = new Date().getTime()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.participatetero div {
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/tero/Participate.vue